import React from 'react';
import styled from 'styled-components';
import { IonItem, IonLabel, IonNote } from '@ionic/react';
import { Case } from '../../../services/buildfire/rdb/cases';
import { useHistory } from 'react-router-dom';

interface CaseTypeProps {
  case: Case;
  isAdmin: boolean;
}

const Item = styled(IonItem)`
  --padding: 0;
`;
const UpgradeButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const CaseType: React.FC<CaseTypeProps> = ({ case: c, isAdmin }) => {
  const history = useHistory();
  return (
    <Item
      button
      id="case-info_case-type"
      onClick={(e) => {
        history.push(`${c.id}/edit-case-type`, { from: 'caseInfo' });
      }}
      detail
    >
      <IonLabel color={c.priority ? 'primary' : undefined}>
        {c.priority ? 'Priority Case' : 'Standard Case'}
        <br />
        <IonNote>
          {c.priority
            ? '2 hour turnaround time*'
            : '24hr turnaround time (weekdays only)'}
        </IonNote>
      </IonLabel>

      {!c.priority && (
        <UpgradeButtonContainer slot="end">
          <IonNote color="medium">Upgrade</IonNote>
        </UpgradeButtonContainer>
      )}
    </Item>
  );
};

export default CaseType;
